import * as BySquare from 'bysquare'

import type { Payment } from 'bysquare'

type GenerateBySquareCodeProps = Pick<
  Payment,
  'amount' | 'paymentNote' | 'variableSymbol' | 'beneficiary' | 'bankAccounts'
>

export function generateBySquareCode({
  amount,
  paymentNote,
  variableSymbol,
  beneficiary,
  bankAccounts,
}: GenerateBySquareCodeProps): string {
  const bySquareData: BySquare.DataModel = {
    payments: [
      {
        type: BySquare.PaymentOptions.PaymentOrder,
        currencyCode: BySquare.CurrencyCode.EUR,
        amount,
        paymentNote,
        variableSymbol,
        beneficiary,
        bankAccounts,
      },
    ],
  }

  try {
    return BySquare.encode(bySquareData)
  } catch (error) {
    console.error(error)
    return ''
  }

  return BySquare.encode(bySquareData)
}
